// The input template members download from the tool. files.jointimpactmodel.org serves it straight from
// the team's SharePoint (the Cloudflare Worker in the "files" repo), so replacing the file there updates
// what members get without a deploy; only a new file name (a new release) needs a change here.
export const INPUT_TEMPLATE_URL = "https://files.jointimpactmodel.org/JIM_Input_Template_JIM_4.2.2.xlsx";

// The previous release, kept running for a transition period after a layout change (see the announcement).
// The footer links to it until `until`, so the link retires itself with the instance; move the date if Ops
// extends the instance, or set it in the past to drop the link early.
export const PREVIOUS_RELEASE = {
    label: "JIM 4.2",
    url: "https://v42.jointimpactmodel.org",
    host: "v42.jointimpactmodel.org", // shown as the link text, so it reads as a place to run, not a document
    until: "2027-06-30", // last day the link is shown, YYYY-MM-DD
};

export const previousReleaseLive = (now: Date = new Date()): boolean => now <= new Date(`${PREVIOUS_RELEASE.until}T23:59:59`);
